export interface CanvasSize {
	height: number;
	width: number;
}

/**
 * Fits canvas dimensions within the browser's supported pixel budget.
 * Android and iOS devices use a three-million-pixel budget; other environments
 * use ten million pixels. Larger canvases retain their aspect ratio with whole
 * pixel dimensions, while canvases already within budget retain their size.
 *
 * @param width Requested canvas width in pixels.
 * @param height Requested canvas height in pixels.
 * @returns Canvas dimensions within the current device's pixel budget.
 */
export default function getCanvasSize(
	width: number,
	height: number,
): CanvasSize {
	const userAgent = typeof navigator === 'undefined'
		? ''
		: navigator.userAgent;
	const maximumPixels = /Android|iPhone|iPad|iPod/i.test(userAgent)
		? 3_000_000
		: 10_000_000;
	const requiredPixels = width * height;

	if (requiredPixels <= maximumPixels) {
		return {
			height,
			width,
		};
	}

	const scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);

	return {
		height: Math.floor(height * scalar),
		width: Math.floor(width * scalar),
	};
}
